import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useMessageTileStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.customPalette.white,
      color: theme.customPalette.darkBlue,
    },
    icon: {
      paddingTop: '5px',
      marginBottom: '-25px',
      '& svg': {
        fill: '#EA6073',
      },
    },
  })
);
